import { render, staticRenderFns } from "./PasswordH5.vue?vue&type=template&id=2efbf86a&scoped=true"
import script from "./PasswordH5.vue?vue&type=script&lang=js"
export * from "./PasswordH5.vue?vue&type=script&lang=js"
import style0 from "./PasswordH5.vue?vue&type=style&index=0&id=2efbf86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbf86a",
  null
  
)

export default component.exports